/* unplugin-vue-components disabled */import { render } from "./longyanapp.vue?vue&type=template&id=244d668d&scoped=true"
import script from "./longyanapp.vue?vue&type=script&lang=js"
export * from "./longyanapp.vue?vue&type=script&lang=js"

import "./longyanapp.vue?vue&type=style&index=0&id=244d668d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-244d668d"]])

export default __exports__